import { InteractionType } from '@loyalty/shared-common/profile-api-client';

/**
 * Starter Handlebars templates for new Interactions, keyed by {@link InteractionType}.
 *
 * Compile context = {@link ProfileInteractionPayload} from ADR-0002: header fields
 * (`label`, `status`, `eventTimestamp`, …) plus `details[]` (newest first). Each detail
 * has `status`, `eventTimestamp`, and optional `data` (partner-specific jsonb).
 *
 * STORE_RECEIPT: matches tools/hashting/interaction_mapping.jsonata — line items in
 * `details.[0].data.items`, optional store/amount/currency on `data`.
 */
const STORE_RECEIPT_DETAIL_TEMPLATE = `<div class="qlf-receipt" data-testid="interaction-detail">
  <h3 class="qlf-receipt__title">{{label}}</h3>

  {{#with details.[0]}}
    <p class="qlf-receipt__status" data-status="{{status}}">
      <strong>{{status}}</strong>
      {{#if data.reason}}— {{data.reason}}{{/if}}
    </p>
    {{#if data.store}}
      <p class="qlf-receipt__meta">
        {{data.store}}
        {{#if data.date}}· {{data.date}}{{/if}}
      </p>
    {{/if}}

    {{#if data.items.length}}
      <table class="qlf-receipt__items" style="width: 100%;">
        <thead>
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Unit price</th>
          </tr>
        </thead>
        <tbody>
          {{#each data.items}}
            <tr>
              <td>
                {{name}}
                {{#if ean}}<br /><small>EAN {{ean}}</small>{{/if}}
              </td>
              <td>{{quantity}}</td>
              <td>{{unit_price}} {{../data.currency}}</td>
            </tr>
          {{/each}}
        </tbody>
        {{#if data.amount}}
          <tfoot>
            <tr>
              <th colspan="2">Total</th>
              <th>{{data.amount}} {{data.currency}}</th>
            </tr>
          </tfoot>
        {{/if}}
      </table>
    {{else}}
      <p class="qlf-receipt__no-items">No line items were sent for this receipt.</p>
    {{/if}}
  {{/with}}

  <h4 class="qlf-receipt__history-title">History</h4>
  <ol class="qlf-receipt__history" style="list-style-position: inside; padding-left: 0; margin: 0 auto; display: table; text-align: left;">
    {{#each details}}
      <li data-status="{{status}}">{{status}} — {{eventTimestamp}}</li>
    {{/each}}
  </ol>
</div>`;

const STARTER_DETAIL_TEMPLATES: Record<InteractionType, string> = {
  STORE_RECEIPT: STORE_RECEIPT_DETAIL_TEMPLATE,
};

export function getStarterDetailTemplate(type: InteractionType): string {
  return STARTER_DETAIL_TEMPLATES[type];
}
